import type { RequestEstimateModificationPayload } from '@massilia/contracts'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useRequestMyEstimateModificationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      responseId,
      ...payload
    }: RequestEstimateModificationPayload & { responseId: string }) => {
      const response = await apiClient.client.post(
        `/me/estimate-responses/${responseId}/modification-request`,
        payload
      )
      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: meKeys.estimates })
    },
  })
}
